var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import "blocks/Scoreboard/Scoreboard.less";
import { Loader } from "sb-resp-ui";
import { ScoreboardTypes } from "../../Constants";
var Scoreboard = /** @class */ (function (_super) {
    __extends(Scoreboard, _super);
    function Scoreboard(props) {
        var _this = _super.call(this, props) || this;
        _this.dict = _this.props.dict;
        _this.state = {
            dataProvider: _this.props.dataProvider,
        };
        return _this;
    }
    Scoreboard.prototype.render = function () {
        var ScoreboardComponent = ScoreboardTypes[this.state.dataProvider.scoreboardType];
        return (!this.state.dataProvider.isDataLoaded
            ? React.createElement(Loader, null)
            : React.createElement(ScoreboardComponent, { scoreboardData: this.state.dataProvider.data, backgroundImg: this.state.dataProvider.backgroundImg, deviceDetect: this.state.dataProvider.deviceDetect, dict: this.dict }));
    };
    Scoreboard = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], Scoreboard);
    return Scoreboard;
}(React.Component));
export { Scoreboard };
//# sourceMappingURL=Scoreboard.js.map